<!-- Hero: fondo.png de landing2, letras a la izquierda y personas a la derecha -->
<section class="hero-landing2">
    <div class="container">
        <div class="row">

            <div class="col-12 col-md-6 my-auto text-center" data-aos="zoom-in">
                <img src="/assets/images/sorteo2026/landing2/letras.png" class="img-fluid hero2-letras"
                    alt="Lista de ganadores del Sorteo Egresados Anáhuac">
            </div>

        </div>
    </div>
</section>

<br><br>
<section class="stc-winners-opt anahuac">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 class="titulo-oficial">
                    LISTA DE GANADORES DEL SORTEO
                    <span class="d-block">
                        EGRESADOS ANÁHUAC 2026
                    </span>
                </h2>
            </div>

            <div class="col-md-12 ">
                <div class=" text-center" style="overflow-x: auto;">

                    <table class="table table-striped ">

                        <thead class="text-center">
                            <tr class="text-center cols">
                                <th scope="col"><span>No. DE PREMIO</span></th>
                                <th scope="col"><span>NOMBRE</span></th>

                                <th scope="col"><span>VALOR</span></th>
                                <th scope="col"><span>FOLIO</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Tres premios, los mismos que traia el grid de
                                 recuadros que estaba aqui. Los datos van en
                                 XXXX hasta que se libere la lista: solo hay
                                 que sustituirlos aqui. Si el sorteo termina
                                 con mas o menos premios, se agregan o quitan
                                 <tr> alternando .first y .second. -->
                            <tr class="text-center first">
                                <td>1</td>
                                <td>Juliette A. K.</td>

                                <td>$150,000.00</td>
                                <td>000060</td>
                            </tr>
                            <tr class="text-center second">
                                <td>2</td>
                                <td>Monica Berenice D. A.</td>

                                <td>$50,000.00</td>
                                <td>001140</td>
                            </tr>


                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-12 mt-5 pt-0 footer-egr">
                <p class="font-bold">
                    SORTEO DE EGRESADOS ANÁHUAC 2026
                </p>

                <p>El Sorteo Anáhuac celebró el viernes 21 de agosto de 2026, a las 10:30 horas, el SORTEO DE EGRESADOS
                    ANÁHUAC en la Universidad Anáhuac México Campus Norte con domicilio en la Av. Universidad Anáhuac
                    no. 46, Huixquilucan, Estado de México. C.P. 52786.Con la presencia de la <strong>C. Rubí Guadalupe
                        Guerrero García</strong>,
                    Inspector de la Secretaría de Gobernación, para dar fe de la legalidad del evento.

                </p>

                <p>
                    De acuerdo con lo establecido en el Permiso No. 20260126PS06 otorgado por la Secretaría de
                    Gobernación a Sorteo Anáhuac, A.C., los resultados de los ganadores, que se han hecho acreedores a
                    un premio, han de ser publicados de forma posterior al evento del sorteo en la página de internet
                    https://www.sorteoanahuac.mx/ y nuestras redes sociales a partir del día 22 de agosto de 2026 y de
                    acuerdo a lo registrado ante SEGOB, solo aparecerá el nombre propio de los ganadores, completándose
                    con las iniciales de cada uno de los apellidos, y adicionalmente, se publicará la lista con los
                    nombres completos de los ganadores en las Instalaciones de la Universidad Anáhuac México Campus
                    Norte, ubicada en la Av. Universidad no. 46 Colonia Lomas de Anáhuac, CP. 52786, Huixquilucan Estado
                    de México.

                </p>

                <p>
                    Los premios serán pagados y entregados de conformidad con lo establecido en las bases de Sorteo, los
                    premios menores a 1,500 veces la Unidad de Medida y Actualización vigente en la República Mexicana
                    para el año 2026 se realizará dentro de los 20 (veinte) días hábiles contados a partir de la
                    celebración del sorteo, en Avenida Universidad Anáhuac N° 46, Col. Lomas Anáhuac, C.P. 52786,
                    Huixquilucan, Estado de México, piso 7 del edificio de Biblioteca, en horario de lunes a jueves de
                    10:00 a 18:00 hrs. y los viernes de 10:00 a 14:00 hrs.

                </p>

                <p>
                    Para más información sobre dónde reclamar la entrega de los premios, documentos necesarios para
                    recibirlos diríjase a: www.sorteoanahuac.mx, o a la oficina del Sorteo Anáhuac, A.C. ubicada en la
                    calle “Av. Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de
                    México o al teléfono: 01(55) 5328-8096 ext 2137.

                </p>

                <p>
                    Las personas que resulten ganadoras deberán presentar una identificación oficial vigente con
                    fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses) y CURP.
                    En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de Juegos
                    y Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2, Col. Juárez,
                    Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono: 01(55) 5209 8800.
                </p>

                <p> <strong>PERMISO SEGOB: 20260126PS06</strong> </p>
            </div>

        </div>
    </div>
</section>